import React from 'react';
import * as Styled from './MRating.styles';
import { MRatingProps, MRatingSize } from './MRating.types';
import { MStarGroup, getAIconSizeForStarGroup } from '../MStarGroup';
import { MStarGroupSize } from '../MStarGroup/MStarGroup.types';
import { ALabel } from '../../atoms/ALabel';
import { ATextInteractive } from '../../atoms/ATextInteractive';
import { AIcon } from '../../atoms/AIcon';

const COMPONENT_NAME = 'm-web-ui-kit-MRating';
export const M_RATING_TEST_ID = 'web-ui-kit-MRating';
const SINGLE_STAR_ICON = 'icon-star-fill';

const RATING_STAR_GROUP_SIZE: Record<MRatingSize, MStarGroupSize> = {
  [MRatingSize.S]: MStarGroupSize.S,
  [MRatingSize.M]: MStarGroupSize.M,
  [MRatingSize.L]: MStarGroupSize.L,
};

export const MRating: React.FC<MRatingProps> = ({
  singleStar = false,
  size = MRatingSize.M,
  mStarGroup,
  aLabel,
  aTextInteractive,
  className,
  ...rest
}) => {
  const starGroupSize = mStarGroup?.size ?? RATING_STAR_GROUP_SIZE[size];
  const iconSize = getAIconSizeForStarGroup(starGroupSize);

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={M_RATING_TEST_ID}
      className={className}
      {...rest}
    >
      <Styled.StarGroupWrapper>
        {singleStar ? (
          <Styled.SingleStarWrapper>
            <AIcon icon={SINGLE_STAR_ICON} size={iconSize} />
          </Styled.SingleStarWrapper>
        ) : (
          <MStarGroup {...mStarGroup} size={starGroupSize} />
        )}
      </Styled.StarGroupWrapper>

      <Styled.LabelWrapper>
        <ALabel {...aLabel} />
      </Styled.LabelWrapper>

      <Styled.TextInteractiveWrapper>
        <ATextInteractive {...aTextInteractive} />
      </Styled.TextInteractiveWrapper>
    </Styled.Wrapper>
  );
};

export * from './MRating.types';
